import ReactJson from "@microlink/react-json-view";
import React from "react";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigJsonPanel: React.FC = () => {
  const { watch } = useFormConfigContext();

  const { config } = watch();
  return <ReactJson name={null} theme="bright:inverted" src={config} />;
};

export default ConfigJsonPanel;
